import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
import buttonAnimation from "./buttonMotion"; // 主题1、3 动画模板整体控制

var allAnimations = function allAnimations(props) {
  var button = getThemeData(props, 'buttonMotion');
  return css(["", ""], button.motion === 'shake' ? buttonAnimation.shake : '');
};
export default allAnimations;